import axios from "axios"
// import io from 'socket.io-client'

//apply base url for axios
export const API_URL = "https://koru-backend.herokuapp.com"

const axiosApi = axios.create({
  baseURL: API_URL,
})

axiosApi.interceptors.request.use(req => {
  if (localStorage.getItem("authUser")) {
    req.headers.Authorization = `Bearer ${
      JSON.parse(localStorage.getItem("authUser")).token
    }`
  }

  return req
})

axiosApi.interceptors.response.use(
  response => response,
  error => Promise.reject(error)
)

export async function get(url, config = {}) {
  return await axiosApi.get(url, { ...config }).then(response => response.data)
}

export async function post(url, data, config = {}) {
  return axiosApi
    .post(url, { ...data }, { ...config })
    .then(response => response.data)
}

export async function put(url, data, config = {}) {
  return axiosApi
    .put(url, { ...data }, { ...config })
    .then(response => response.data)
}

export async function del(url, config = {}) {
  return await axiosApi
    .delete(url, { ...config })
    .then(response => response.data)
}
